/* eslint-disable */
(function ($) {
    $(document).ready(function () {
        let serviceFormIds = [3611, 3631];
        if (typeof window.BorlabsCookie !== 'undefined') {
            if (window.BorlabsCookie.Consents.hasConsent('google-analytics')) {
                $('footer .btn-contact').on('click', function () {
                    gtag('event', 'Klick', {
                        'event_category': 'Kontakt',
                        'event_label': 'Kontaktanfrage',
                    });
                });

                $('header a.phone-link').on('click', function () {
                    gtag('event', 'klick', {
                        'event_category': 'anruf',
                        'event_label': 'anrufheader',
                    });
                });
                $('header a.mail-link').on('click', function () {
                    gtag('event', 'klick', {
                        'event_category': 'email',
                        'event_label': 'emailheader',
                    });
                });

                document.addEventListener('wpcf7submit', function (event) {
                    if (serviceFormIds.includes(event.detail.contactFormId) && event.detail.status === 'mail_sent') {
                        gtag('event', 'versenden', {
                            'event_category': 'kontaktformular',
                            'event_label': 'serviceanfrage',
                        });
                    }
                }, false);
            }
        }
    });
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/ga.js